import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';

import './index.css';
import App from './app/App';

import {
  ThemeProvider as ThemeChangeProvider,
  ThemeStateContext,
} from './themes/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

document.appInitPhase = 'STARTING UP APPLICATION';

root.render(
  <ThemeChangeProvider>
    <ThemeStateContext.Consumer>
      {theme => (
        <MuiThemeProvider theme={theme}>
          <LegacyThemeProvider theme={theme}>
            <App />
          </LegacyThemeProvider>
        </MuiThemeProvider>
      )}
    </ThemeStateContext.Consumer>
  </ThemeChangeProvider>
);